import Material from "./Material";

export default class DiffuseMaterial extends Material{
  // No other variables
}
